import type { STChartType } from '@tencent/chart-drawer-components/lib/interface';

export const MAX_TITLE_LENGTH = 30;
export const MAX_SUB_TITLE_LENGTH = 40;


export interface IChartTypeConfig {
    type: STChartType;
    name: string;
    icon: string;
}

export enum ChartGroupKey {
    Column,
    Bar,
    Line,
    Pie,
    Area,
    Scatter,
    Stock,
    Radar,
    Combo,
    Other,
}

export const TITLE_MAX_CHAR_COUNT = 256;
